<template>
  <div class="prompt">
    <div>
      <div class="prompt_content">{{ content }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "prompt",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
</style>